<template>
    <div>
        <!-- Main Content -->
        <div class="main-block request-management">
            <Breadcrumbs />
            <div class="div col-12 p-0 d-flex align-items-start">
                <h4 class="">{{ $t('title.Inbox') }}</h4>
            </div>
            <div class="scrollable-block">
                <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">

                    <crud-table :columns="columns"     :items="dataSources"
                                :list-url="listUrl" ref="application-table"
                        v-on:refresh="fetchEmails">

                        <template slot>
                            <b-button variant="primary" @click="$router.go(-1)">
                                <b-icon icon="arrow-left" class="icon-style"></b-icon>
                            </b-button>
                        </template>

                        <template #cell(actions)="{ item }">
                            <b-button variant="light" @click="openModal(item)">
                                <b-icon variant="primary" icon="eye" class="icon-style"></b-icon>
                            </b-button>
                        </template>

                    </crud-table>

                    <!-- Load More Button -->
                    <div class="text-center mt-3" v-if="pagination.nextPageToken">
                        <b-button variant="primary" @click="loadMoreEmails">{{ $t('title.load_more') }}</b-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Fullscreen Modal -->
        <div class="modal fade" :id="'fullscreen-modal'" role="dialog" :aria-labelledby="'fullscreen-modal-label'"
            :aria-hidden="!showPopup">
            <div class="modal-dialog modal-fullscreen modal-dialog-centered custom-modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fullscreen-modal-label">{{ $t('title.view_details') }}</h5>
                    </div>
                    <div class="modal-body">
                        <!-- Display selected item details -->
                        <div v-if="selectedItem">
                            <h5>{{ selectedItem.subject }}</h5>
                            <p><strong>{{ $t('title.date') }}:</strong> {{ formatDate(selectedItem.date) }}
                            </p>
                            <p><span v-html="selectedItem.snippet"></span>
                            </p>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="closeModal">
                                <span aria-hidden="true">close</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Modal
} from "bootstrap";
import { request } from "@/Util/Request";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null,
};
const COLUMN_STATE = (self) => [
    {
        key: 'from',
        label: self.$t('title.from'),
        sortable: true
    },
    {
        key: 'to',
        label: self.$t('title.to'),
        sortable: true
    },
    {
        key: 'subject',
        label: self.$t('title.subject'),
        sortable: true
    },
    {
        key: 'actions',
        label: self.$t('title.actions')
    }
];


export default {
    data() {
        return {
            dataSources : [], // Stores fetched emails
            operation: '',
            query: {
                page: 1,
                perPage: 10,
                pageToken: null,
            },
            pagination: {
                total: 0,
                nextPageToken: null
            },
            integrations: [],
            filters: { ...FILTER_FORM },
            showPopup: false,
            modalInstance: null,
            selectedItem: null,
            visibleFields: {},
            submenuItems: [],
            columns: COLUMN_STATE(this) // Dynamically set columns
        };
    },
    mounted() {
        this.fetchEmails().then(() => {
            if(this.$route.query.subject) {
                this.$refs['application-table'].handleCustomSearch(this.$route.query.subject);
            }
        }); // Fetch data on component load
    },
    components: { Breadcrumbs },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString(this.$i18n.locale);  // Uses locale from i18n
        },
        handleFilter() {
            // Reset pagination when filters change
            this.query.page = 1;

            // Apply the filter and pass filters to the table's handleFilter method
            this.$refs['application-table'].handleFilter({ filters: this.filters });

        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.query.page = 1;  // Reset pagination when resetting filters
        },
        redirectToHome(item) {
            this.$router.push('/home');
        },
        openModal(item) {
            this.selectedItem = item;
            this.showPopup = true;
            // Create modal instance using Bootstrap Modal API
            const modal = new Modal(document.getElementById('fullscreen-modal'));
            modal.show();
        },

        closeModal() {
            this.showPopup = false;
            const modal = new Modal(document.getElementById('fullscreen-modal'));
            modal.hide();
        },
        async fetchEmails() {
            try {
                const response = await request(this.listUrl);


                if (response.original.data) {

                    // Map API response to expected column keys
                    this.dataSources = response.original.data.map(item => ({
                        from: item.from, // Adjust if API field names differ
                        to: item.to,
                        subject: item.subject,
                        date: item.date,
                        // snippet: item.messagePreview, // If needed
                        id: item.id // Ensure each row has a unique identifier
                    }));

                    this.pagination.total = response.original.total || 0;
                    this.pagination.nextPageToken = response.original.nextPageToken || null;
                }
            } catch (error) {
                console.error('Error fetching emails:', error);
            }
        },

        async loadMoreEmails() {
            if (!this.pagination.nextPageToken) return;

            try {
                const response = await request(`${this.listUrl}?pageToken=${this.pagination.nextPageToken}`);
                const data = await response.json();

                if (data.data) {
                    this.emails.push(...data.data); // Append new data
                    this.pagination.nextPageToken = data.nextPageToken || null;
                }
            } catch (error) {
                console.error('Error loading more emails:', error);
            }
        }


    },
    computed: {
        listUrl() {
        return `${process.env.VUE_APP_API_URL}admin/getGSuitUserMailBox/${this.$route.params.id}`;
        },
        // columns() {
        //     return COLUMN_STATE(this);
        // }
    }
};
</script>

<style scoped>
.custom-modal-dialog {
    max-width: 80%;
    margin-top: 2%;
}
</style>
